import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  TravelCountryStart,
  TravelCountrySuccess,
  TravelCountryFailure,
} from "../reducers/getTravelCountryReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const getTravelCountry = createAsyncThunk(
  "getTravelCountry",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(TravelCountryStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Travel/GetCountry`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(TravelCountrySuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(TravelCountryFailure(error.response.data.Message));
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
